import { Navigate, Routes, Route } from "react-router-dom";

import NotFoundPage from "../../components/Page/NotFoundPage/NotFoundPage";
import PublicLayout from "../../layouts/PublicLayout/PublicLayout";
import { baseRoute } from "../../utils";

const PublicContainer = ({ isOrgan = false }) => {
  return (
    <PublicLayout>
      <Routes>
        {/* Redirect Not Found Page */}
        <Route
          index
          element={<Navigate to={baseRoute(isOrgan, "/Auth/Sign-In")} />}
        />

        {/* Not Found Component */}
        <Route path="*" element={<NotFoundPage isOrgan={isOrgan} />} />
      </Routes>
    </PublicLayout>
  );
};

export default PublicContainer;
